export default __webpack_public_path__ + "static/media/IMG_0162.8ba18602.jpg";